import { createKeyFactory } from '@clouway/query'

export const vendorsKeys = createKeyFactory('vendors')

export const vendorsAllKey = () => vendorsKeys.all()

export const vendorModelsKey = (vendorId: string) => vendorsKeys.custom('models', vendorId)
